enum ButtonIcon {
  DOWNLOAD = 'download',
  OPEN = 'open',
}

export default ButtonIcon;
